import { render, staticRenderFns } from "./number-x-keyboard.vue?vue&type=template&id=0e3908bd&scoped=true&"
import script from "./number-x-keyboard.vue?vue&type=script&lang=js&"
export * from "./number-x-keyboard.vue?vue&type=script&lang=js&"
import style0 from "./number-x-keyboard.vue?vue&type=style&index=0&id=0e3908bd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3908bd",
  null
  
)

export default component.exports